$(function () {
    const sumoSelectGraveyard = $('.select--graveyard');
    sumoSelectGraveyard.SumoSelect({
        search: true,
        searchText: 'Összes temető',
        noMatch: 'Nincs találat'
    });
});